import { TextField } from '@mui/material';

import React, { useState, useEffect, useRef } from 'react'
import './Chat.scss'
import { useLocation } from 'react-router-dom';
import { getCommentData, deleteComment, readComments, SaveAdminComments, SaveCommunityComments, SaveLenderComments, getAssignedLenders, getCommentDataByLenderIdAdmin, getCommentDataByUserIdAdmin, getCommentDataByCommmunityIdAdmin, getCommentDataByOperationId, pokeMsg, resetRemainder } from '../../CommunityActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component';
import SelectField from '../../../CommonComponents/SelectMUI'
import moment from 'moment';
import WindowImage from '../../Images/pop-up.png'
import Draggable from 'react-draggable';



let rolesData = window.sessionStorage.getItem('rolesData');



const ChatScreen = ({ rowData}) => {

    const [logsData, setLogsData] = useState('')
    const location = useLocation();
    const [comment, setComment] = useState('')
    const [loaderState, setLoaderState] = useState(false)
    const [unread, setUnread] = useState(0)
    const bottomRef = useRef(null);
    const [sendAs, setSendAs] = useState('USER')
    const [errorMsg, setErrorMsg] = useState('')
    const [receiverdataAdmin, setReceiverDataAdmin] = useState([])
    const [viewScreen, setviewScreen] = useState('user')
    const [assignedLender, setAssignedLender] = useState([])
    const [commentLenderId, setlenderId] = useState('')
    const [userchatDataUser, setuserchatDataUser] = useState('')
    const [userChatWindow, setuserChatWindow] = useState(false)
    const [commentUser, setcommentUser] = useState('')
    const [communityChatWindow, setcommunityChatWindow] = useState(false)
    const [communityChatData, setcommunityChatData] = useState(false)
    const [commentCommunity, setcommentCommunity] = useState('')
    const [lenderChatWindow, setlenderChatWindow] = useState(false)
    const [commentLender, setcommentLender] = useState('')
    const [lenderChatData, setlenderChatData] = useState('')
    const [chatLenderId, setChatLenderId] = useState('')
    const [activeDrags, setactiveDrags] = useState(0)

    let colors = [
        {
            code: 1,
            color: '#ffbebe'
        },
        {
            code: 2,
            color: '#ff9b9b'
        },
        {
            code: 3,
            color: 'rgb(237 105 105)'
        },
    ]

    const findColor = (key, type) => {
        let color = '';
        if (key === 0 && type === 'other') {
            color = '#dedee5'
        }
        else if (key === 0 && type === 'you') {
            color = '#d8ebd8'
        } else {
            var filterData = colors.filter(item => item.code === key);
            if (filterData) {
                color = filterData[0].color
            }
        }
        return color;
    }


    const commentHandler = (e) => {

        // setLoaderState(true)
        let apiToCall = window.sessionStorage.getItem('communityId') !== '' && window.sessionStorage.getItem('communityId') !== 'null' && window.sessionStorage.getItem('communityId') !== null ? SaveCommunityComments : SaveLenderComments
        comment ? apiToCall(rowData, comment, callBack => {
            if (callBack.message === 'success') {
                // setUnread(unread+1)
                getAllCommentData();
                setComment("");
            } else {

            }
        },
            error => {

            }) : console.log("", "Null value");
        // setLoaderState(false)

    }
    const minimizeChatData = (type, id) => {
        if (type === 'user') {
            getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                setuserchatDataUser(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)
                setuserChatWindow(true)

            })
        }
        if (type === 'community') {
            getCommentDataByCommmunityIdAdmin(rowData.loanId, rowData.communityId, callBack => {
                setcommunityChatData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)
                setcommunityChatWindow(true)

            })
        }
        if (type === 'lender') {
            setChatLenderId(id)
            getCommentDataByLenderIdAdmin(rowData.loanId, id, callBack => {
                setlenderChatData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)
                setlenderChatWindow(true)
            })
        }
    }
    const getAssignedLendersByApi = () => {
        getAssignedLenders(rowData.loanId, callBack => {
            console.log(callBack)
            setAssignedLender(callBack.data)
        })
    }
    const commentChangeHandler = (e) => {
        setComment(e.target.value)
    }
    const commentChangeHandlerUser = (e, type) => {
        if (type === 'type') {
            setcommentUser(e.target.value)
        }
        if (type === 'send') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'userId': rowData.userId,
                'body': commentUser,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                        setuserchatDataUser(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setcommentUser("");
                } else {

                }
            })
        }
    }
    const commentChangeHandlerCommunity = (e, type) => {
        if (type === 'type') {
            setcommentCommunity(e.target.value)
        }
        if (type === 'send') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'communityId': rowData.communityId,
                'body': commentCommunity,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByCommmunityIdAdmin(rowData.loanId,rowData.communityId, callBack => {
                        setcommunityChatData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setcommentCommunity("");
                } else {

                }
            })
        }
    }
    const commentChangeHandlerLender = (e, type, lenderId) => {

        if (type === 'type') {
            setcommentLender(e.target.value)
        }
        if (type === 'send') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'lenderId': chatLenderId,
                'body': commentLender,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByLenderIdAdmin(rowData.loanId, lenderId, callBack => {
                        setlenderChatData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)
                    })
                    setcommentLender("");
                } else {

                }
            })
        }
    }
    const getAllCommentData = () => {
        // getCommentData(location.state.rowData.loanId, callBack => {
        //     setLogsData(callBack)
        //     bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
        //     console.log(callBack, "CALLBACK")
        // }, error => {

        // })
        getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
            setLogsData(callBack)
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
            setLoaderState(false)

        })
    }
    const acknowledged = (e) => {

        setLoaderState(true)
        readComments(rowData.loanId, window.sessionStorage.getItem("adminId") || "admin",
            rowData.communityId || window.sessionStorage.getItem("communityId"), callBack => {
                setUnread(0)
                setLoaderState(false)
            }, error => {
                setLoaderState(false)
            })
    }

    const resetRemainderCount = (e) => {

        setLoaderState(true)
        resetRemainder(rowData.loanId, callBack => {
            setUnread(0)
            getAllCommentData()
            setLoaderState(false)
        }, error => {
            setLoaderState(false)
        })
    }

    useEffect(() => {
        console.log(rowData, 'location.state.rowData')
        getAllCommentData();
        rowData && rowData.unReadComments ? setUnread(rowData.unReadComments) : setUnread(0)
        getReceiverdata()
        getAssignedLendersByApi()
    }, [])

    const getReceiverdata = () => {
        let x = []
        x.push({ code: 'LENDER', name: 'Lender' })
        x.push({ code: 'USER', name: 'User' })
        if (rowData && rowData.communityId) {
            x.push({ code: 'COMMUNITY', name: 'Community' })
        }
        setReceiverDataAdmin(x)
    }
    const sendToHandler = (value) => {
        if (value) {
            console.log(value)
            setSendAs(value)
            setErrorMsg('')
        }
    }

    const deleteComments = (e) => {
        // alert(e)
        deleteComment(e, callBack => {
            getAllCommentData();
        }, error => {

        })
    }

    const poke = (e) => {
        // alert()
        setLoaderState(true)
        pokeMsg(e, rowData.loanId, callBack => {
            getcommentAccordingToTabs();
            setLoaderState(true)
        }, error => {
            setLoaderState(true)
        })
    }
    const getcommentAccordingToTabs = () => {
        console.log(viewScreen, 'screen')
        if (viewScreen === 'community') {
            getCommentDataByCommmunityIdAdmin(rowData.loanId, rowData.communityId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }

        if (viewScreen === 'internal') {
            getCommentDataByOperationId(rowData.loanId, '', callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })


        }

        if (viewScreen === 'user') {
            getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })

        }
    }
    const adminCommentHandler = () => {
        console.log(viewScreen, 'screen')
        if (viewScreen === 'community') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'communityId': rowData.communityId,
                'body': comment,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByCommmunityIdAdmin(rowData.loanId, rowData.communityId, callBack => {
                        setLogsData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setComment("");
                } else {

                }
            })
        }
        if (viewScreen === 'internal') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'body': comment,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByOperationId(rowData.loanId, '', callBack => {
                        setLogsData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setComment("");
                } else {

                }
            })
        }

        if (viewScreen === 'user') {
            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'userId': rowData.userId,
                'body': comment,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                        setLogsData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setComment("");
                } else {

                }
            })
        }
        if (viewScreen.includes('lender') && commentLenderId) {

            let CommunityData = {
                'loanId': rowData.loanId,
                'applicationId': rowData.applicationId,
                'lenderId': commentLenderId,
                'body': comment,
                'operationId': window.sessionStorage.getItem('adminId')

            }
            SaveAdminComments(CommunityData, callBack => {
                if (callBack.message === 'success') {
                    getCommentDataByLenderIdAdmin(rowData.loanId, commentLenderId, callBack => {
                        setLogsData(callBack)
                        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                        setLoaderState(false)

                    })
                    setComment("");
                } else {

                }
            })
        }

    }
    const leadPageHandler = (type, data) => {
        if (type === 'user') {
            setviewScreen(type)

            setLoaderState(true)
            getCommentDataByUserIdAdmin(rowData.loanId, rowData.userId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }
        if (type === 'community') {
            setviewScreen(type)
            setLoaderState(true)
            getCommentDataByCommmunityIdAdmin(rowData.loanId, rowData.communityId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }
        if (type === 'lender') {
            let view = type + data.lenderId
            setviewScreen(view)
            setlenderId(data.lenderId)
            setLoaderState(true)
            getCommentDataByLenderIdAdmin(rowData.loanId, data.lenderId, callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)
                setlenderId(data.lenderId)
            })
        }
        if (type === 'internal') {
            setviewScreen(type)

            setLoaderState(true)
            getCommentDataByOperationId(rowData.loanId, '', callBack => {
                setLogsData(callBack)
                bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                setLoaderState(false)

            })
        }
    }
    const chatCloseHandler = (type) => {
        if (type === 'user') {
            setuserChatWindow(false)
        }
        if (type === 'community') {
            setcommunityChatWindow(false)
        }
        if (type === 'lender') {
            setlenderChatWindow(false)
        }
    }
    const onStart = () => {
        setactiveDrags(++activeDrags)
    };

    const onStop = () => {
        setactiveDrags(--activeDrags)
    };

    return (

        <div className="container-fluid full-height">

            {loaderState ?
                <Loader />
                : ""}
            {userChatWindow ?
                <Draggable >
                    <div className='chat-small-box' id="mydiv" style={{overflowX:'hidden'}}>
                        <div className='header-chat' id="mydivheader">
                            User Chat <i className='fa fa-close' onClick={() => chatCloseHandler('user')} style={{ marginRight: '10px', marginTop: '5px' }}></i>
                            {/* <div className='text-right'>
                                <i className='fa fa-close' style={{ color: 'red', marginRight: '10px', marginTop: '10px' }}></i>
                            </div> */}
                        </div>
                        {userchatDataUser && userchatDataUser.data && userchatDataUser.data.map((row, i) => {
                            return (
                                <div key={i} className='container'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <h6>
                                                {row["operationName"] ? row['operationName'] : row['communityName'] ? row['communityName'] : row['userName'] ? row['userName'] : ''}

                                            </h6>
                                            {/* <p className=''> {row["body"]}</p> */}
                                        </div>
                                        <div className='col-sm-6 text-right'><p style={{ fontSize: '12px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</p></div>
                                        <p className='' style={{ fontSize: '15px', color: 'gray' }}> {row["body"]}</p>

                                    </div>
                                    <hr style={{ marginTop: 0, marginBottom: 0 }} />

                                </div>

                            )
                        })}
                        <div className='container comment-div' style={{ position: userchatDataUser && userchatDataUser.data && userchatDataUser.data.length < 4 ? 'absolute' : !userchatDataUser.data ? 'absolute' : 'sticky' }} >
                            <div className='row'>
                                <div className='col-sm-10 col-xs-12'>
                                    <TextField variant='standard' size='small' onChange={(e) => commentChangeHandlerUser(e, 'type')} type="text" className="form-control" value={commentUser} label="Add Comment" 
                                        style={{background:'#fff',boxShadow:'none',borderRadius:'0'}}/>
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <i className='fa fa-send' onClick={(e) => commentChangeHandlerUser(e, 'send')} ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
                : ""}
            {communityChatWindow ?
                <Draggable >
                    <div className='chat-small-box' style={{ right: userChatWindow ? '350px' : 0 ,overflowX:'hidden'}}>
                        <div className='header-chat'>
                            Community Chat <i className='fa fa-close' onClick={() => chatCloseHandler('community')} style={{ marginRight: '10px', marginTop: '5px' }}></i>
                            {/* <div className='text-right'>
                                <i className='fa fa-close' style={{ color: 'red', marginRight: '10px', marginTop: '10px' }}></i>
                            </div> */}
                        </div>
                        {communityChatData && communityChatData.data && communityChatData.data.map((row, i) => {
                            return (
                                <div key={i} className='container'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <h6>
                                                {/* {row["communityName"]}   {row["lenderName"]}   {row.userName} */}
                                                {row["operationName"] ? row['operationName'] : row['communityName'] ? row['communityName'] : row['userName'] ? row['userName'] : row['lenderName']}

                                            </h6>

                                        </div>
                                        <div className='col-sm-6 text-right'><p style={{ fontSize: '12px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</p></div>
                                        <p className='' style={{ fontSize: '15px', color: 'gray' }}> {row["body"]}</p>
                                    </div>
                                    <hr style={{ marginTop: 0, marginBottom: 0 }} />

                                </div>

                            )
                        })}
                        <div className='container comment-div' style={{ position: communityChatData && communityChatData.data && communityChatData.data.length < 4 ? 'absolute' : !communityChatData.data ? 'absolute' : 'sticky' }} >
                            <div className='row'>
                                <div className='col-sm-10 col-xs-12'>
                                    <TextField variant='standard' size='small' onChange={(e) => commentChangeHandlerCommunity(e, 'type')} type="text" className="form-control" value={commentCommunity} label="Add Comment" 
                                        style={{background:'#fff',boxShadow:'none',borderRadius:'0'}} />
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <i className='fa fa-send' onClick={(e) => commentChangeHandlerCommunity(e, 'send')} ></i>

                                </div>

                            </div>
                        </div>

                    </div>
                </Draggable>
                : ""}
            {lenderChatWindow ?
                <Draggable >
                    <div className='chat-small-box' style={{ right: communityChatWindow && userChatWindow ? '700px' : (userChatWindow || communityChatWindow) ? '350px' : 0 }}>
                        <div className='header-chat'>
                            Lender Chat <i className='fa fa-close' onClick={() => chatCloseHandler('lender')} style={{ marginRight: '10px', marginTop: '5px' }}></i>
                            {/* <div className='text-right'>
                                <i className='fa fa-close' style={{ color: 'red', marginRight: '10px', marginTop: '10px' }}></i>
                            </div> */}
                        </div>
                        {lenderChatData && lenderChatData.data && lenderChatData.data.map((row, i) => {
                            return (
                                <div key={i} className='container'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <h6>
                                                {/* {row["communityName"]}   {row["lenderName"]}   {row.userName} */}
                                                {row["operationName"] ? row['operationName'] : row['communityName'] ? row['communityName'] : row['userName'] ? row['userName'] : row['lenderName']}

                                            </h6>
                                        </div>
                                        <div className='col-sm-6 text-right'><p style={{ fontSize: '12px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</p></div>
                                        <p className='' style={{ fontSize: '15px', color: 'gray' }}> {row["body"]}</p>

                                    </div>
                                    <hr style={{ marginTop: 0, marginBottom: 0 }} />

                                </div>

                            )
                        })}
                        <div className='container comment-div' style={{ position: lenderChatData && lenderChatData.data && lenderChatData.data.length < 4 ? 'absolute' : !lenderChatData.data ? 'absolute' : 'sticky' }} >
                            <div className='row'>
                                <div className='col-sm-10 col-xs-12'>
                                    <TextField variant='standard' size='small' onChange={(e) => commentChangeHandlerLender(e, 'type', '')} type="text" className="form-control" value={commentLender} label="Add Comment" />
                                </div>
                                <div className='col-sm-2 col-xs-12'>
                                    <i className='fa fa-send' onClick={(e) => commentChangeHandlerLender(e, 'send', '')} ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
                : ""}
            <div className='row ' style={{ height: '90%' }}>
                <div className='col-sm-3 col-xs-12 side-chat-main ' >
                    <div className='comments-side-nav'>

                        <div className={viewScreen === 'user' ? 'chat-user-active' : 'chat-user'} >
                            <div className='row' style={{padding:'5px 0'}}>
                                <div className='col-sm-8 ' style={{ cursor: 'pointer' }} onClick={e => leadPageHandler('user', '')}>

                                    <button >User</button>

                                    <p style={{fontSize:'12px',margin:"3px 0",padding:'0 5px'}}>{rowData.name}</p>
                                </div>
                                {
                                    viewScreen === 'user' ?
                                    <div className='col-sm-4 text-right'>
                                    <div className='minimize-button hide-small-chats'>
                                        <i className="fa fa-window-restore mt-2 " style={{marginRight:'10px'}} aria-hidden="true" onClick={(e) => minimizeChatData('user', '')}></i>
                                    </div>
                                </div>
                                :''}
                            </div>
                        </div>
                        {rowData.communityId ?
                            <div className={viewScreen === 'community' ? 'chat-user-active' : 'chat-user'} style={{marginTop:'10px'}}>
                                {/* <button  >Community </button>
                                <br />
                                <span>{location.state.rowData.communityName}</span> */}
                                <div className='row' style={{padding:'5px 0'}}>
                                    <div className='col-sm-8 ' style={{ cursor: 'pointer' }} s onClick={e => leadPageHandler('community', '')}>
                                        <button >Community</button>
                                        <p style={{fontSize:'12px',margin:"3px 0",padding:'0 5px'}}>{rowData.communityName}</p>
                                    </div>
                                    {
                                        viewScreen === 'community' ?
                                        <div className='col-sm-4 text-right'>
                                        <div className='minimize-button hide-small-chats'>
                                            <i className="fa fa-window-restore mt-2 " style={{marginRight:'10px'}} aria-hidden="true" onClick={(e) => minimizeChatData('community', '')}></i>
                                        </div>
                                    </div>
                                    :''}
                                </div>
                            </div>
                            : ""}
                        <div className={viewScreen === 'internal' ? 'chat-user-active' : 'chat-user'}  style={{marginTop:'10px'}}>
                            <div className='row' style={{padding:'5px 0'}}>
                                <div className='col-sm-12' s onClick={e => leadPageHandler('internal', '')}>

                                    <button >Internal Chat</button>

                                    <p style={{fontSize:'12px',margin:"3px 0",padding:'0 5px'}}>{window.sessionStorage.getItem('emailId')}</p>
                                </div>
                                {/* <div className='col-sm-4 text-right'>
                                    <div className='minimize-button hide-small-chats'>
                                        <i className="fa fa-window-restore mt-2 mr-2" aria-hidden="true" onClick={(e) => minimizeChatData('user', '')}></i>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {assignedLender && assignedLender.map((data, i) => {
                            return (
                                <div className={viewScreen.includes(data.lenderId) ? 'chat-user-active' : 'chat-user'} key={i} >
                                    <div className='row'>
                                        <div className='col-sm-8 ' style={{ cursor: 'pointer' }} onClick={e => leadPageHandler('lender', data)}>
                                            <button> {data.lenderName}</button>
                                            <p>Lender {i + 1}</p>
                                        </div>
                                        <div className='col-sm-4 text-right'>
                                            <div className='minimize-button hide-small-chats'>
                                                <i className="fa fa-window-restore mt-2 mr-2" aria-hidden="true" onClick={(e) => minimizeChatData('lender', data.lenderId)} ></i>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )
                        })}

                    </div>
                </div>
                <div className='col-sm-9  col-xs-12'>
                    <div className='row'>
                        <div className='col-sm-6 col-xs-12'>
                            <h3 className='mt-3 mb-3 text-color'><b> Comments</b></h3>
                        </div>

                        <div className='col-sm-6 col-xs-12 row'>

                            <div className='col-sm-8 col-xs-12'>
                                {
                                    window.sessionStorage.getItem('department') === "admin" ?
                                        <button onClick={(e) => resetRemainderCount(e)} style={{ float: '' }} className="cred-btn mt-3 mb-3">Reset Remainder Count</button>
                                        : ""}
                            </div>

                            <div className='col-sm-4 col-xs-12'>
                                <button onClick={(e) => acknowledged(e)} style={{ float: 'right',fontSize:'16px',marginTop:'12px' }} className="cred-btn mt-3 mb-3">Acknowledged</button>
                            </div>

                        </div>
                    </div>
                    <div className='box bg-shadow' style={{ height: '500px', overflow: 'scroll', width: '100%' }}>
                        {logsData && logsData.data ?

                            <div className="">
                                <div className="mt-3">
                                    {logsData && logsData.data && logsData.data.map((row, i) => {
                                        return (
                                            <div key={i}>
                                                {row.operationId ?
                                                    <div className="chat-message-right pb-4">
                                                        <div className="rounded py-2 px-3 ml-3" style={{ minWidth: '250px', backgroundColor: findColor(row.reminderCount, 'you') }}>

                                                            <div className='row'>
                                                                <div className="font-weight-bold mb-1 col-md-9">{row["operationName"]}</div>
                                                                <div className="mb-1 text-right" style={{ fontSize: '9px', marginTop: '-20px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                            </div>

                                                            {row["body"]}
                                                        </div>
                                                        {
                                                            window.location.href.includes('/admin') ?
                                                                <div className='row' style={row.reminderCount < 3 ?{ marginRight: "-33px" } :{}}>

                                                                    <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                    {
                                                                        row.reminderCount < 3 ?
                                                                            <button onClick={(e) => poke(row.id)}> <b>{row.reminderCount ==0?'': row.reminderCount} &nbsp;</b>  <i className='fa fa-hand-o-right' style={{ cursor: "pointer" }} /> </button>
                                                                            : ''
                                                                    }
                                                                </div> : ""
                                                        }
                                                    </div> :
                                                    <div className="chat-message-left pb-4">
                                                        <div className="flecommunityNamex-shrink-1 rounded py-2 px-3 ml-3" style={{ minWidth: '250px', backgroundColor: findColor(row.reminderCount, 'other') }}>

                                                            <div className='row'>
                                                                <div className="font-weight-bold mb-1 col-sm-7">{row["communityName"] ? row["communityName"] : row["lenderName"] ? row["lenderName"] : row["userId"] ? row.userName : ""}</div>
                                                                <div className="mb-1 col-sm-5 text-right" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                            </div>

                                                            {row["body"]}
                                                        </div>
                                                        {
                                                            window.location.href.includes('/admin') ?
                                                                <div className='ml-2 mt-3'>
                                                                    <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                </div> : ""
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>

                                <div ref={bottomRef} ></div>
                            </div>
                            : ""}
                    </div>
                    {/* {(rolesData && rolesData.includes("comments")) || window.location.href.includes('community/leadDetail') ? */}
                        <div className="flex-grow-0 py-3 px-4 border-top">
                            <div className=" row chat-comment">

                                <div className='col-xs-12 col-sm-9 '>
                                    <TextField variant='standard' size='small' onChange={(e) => commentChangeHandler(e)} type="text" className="form-control" value={comment} label="Add Comment"
                                    style={{background:'#fff',borderRadius:'0',boxShadow:'none'}} />
                                </div>
                                {!window.location.href.includes('admin') ?
                                    <div className='col-xs-12 col-sm-3 mt-3'>
                                        <button onClick={(e) => commentHandler(e)} className="cred-btn"><i className='fa fa-send'></i></button>
                                    </div>
                                    : ""}
                                {window.location.href.includes('admin') ?
                                    // <div className='row'>
                                    //     <div className='col-xs-12 col-sm-4'>
                                    //     </div>
                                    <div className='col-xs-12 col-md-3 ' >
                                        <button onClick={(e) => adminCommentHandler(e)} className="cred-btn" style={{fontSize:'16px'}}><i className='fa fa-send'></i></button>
                                    </div>
                                    // <div className='col-xs-12 col-sm-4'>
                                    // </div>
                                    // </div>
                                    : ""}
                            </div>
                        </div>
                        {/* : ""} */}

                    {/* {(rolesData && rolesData.includes("comments")) || window.location.href.includes('community/leadDetail') ?
                            <div className="flex-grow-0 py-3 px-4 border-top">
                                <div className=" row">

                                    <div className='col-xs-12 col-sm-9'>
                                        <TextField variant='standard' size='small' onChange={(e) => commentChangeHandler(e)} type="text" className="form-control" value={comment} label="Add Comment" />
                                    </div>
                                    {!window.location.href.includes('admin') ?
                                        <div className='col-xs-12 col-sm-3 mt-3'>
                                            <button onClick={(e) => commentHandler(e)} className="cred-btn">Add Comment</button>
                                        </div>
                                        : ""}
                                    {window.location.href.includes('admin') ?
                                        // <div className='row'>
                                        //     <div className='col-xs-12 col-sm-4'>
                                        //     </div>
                                        <div className='col-xs-12 col-md-3 mt-3'>
                                            <button onClick={(e) => adminCommentHandler(e)} className="cred-btn">Add Comment</button>
                                        </div>
                                        // <div className='col-xs-12 col-sm-4'>
                                        // </div>
                                        // </div>
                                        : ""}
                                </div>
                            </div>
                            : ""} */}
                </div>
            </div>
            {/* <div className="edit-profile-menu col-xs-12">
                <div className="btn-group-tab-sub">
                    <div>
                        <button className={viewScreen === 'user' ? 'active' : ''} onClick={e => leadPageHandler('user', '')}>User</button>
                    </div>
                    {location.state.rowData.communityId ?
                        <div>
                            <button className={viewScreen === 'community' ? 'active' : ''} onClick={e => leadPageHandler('community', '')}>Community </button>
                        </div>
                        : ""}
                    {assignedLender && assignedLender.map((data, i) => {
                        return (
                            <div key={i}>
                                <button className={viewScreen.includes(data.lenderId) ? 'active' : ''} onClick={e => leadPageHandler('lender', data)}>{data.lenderName}</button>
                            </div>
                        )
                    })}


                </div>
            </div> */}
            {/* {loaderState ?
                    <Loader />
                    : ""}
                <h1 className="h3 mb-3 mt-4 text-center">Comments </h1>
                <div className="">
                    <div className='row'>
                        <div className='col-xs-12 col-sm-2'>

                        </div>
                        <div className='col-sm-5 col-xs-12'> */}
            {/* {window.location.href.includes('admin') ?
                            <div className='col-xs-12 col-md-6'>
                                <SelectField
                                    value={sendAs}
                                    label={'Send as a'}
                                    onChange={e => sendToHandler(e)}
                                    data={receiverdataAdmin}
                                    size={'small'}
                                    required={true}
                                />
                                <span className='text-danger'>{errorMsg}</span>
                            </div>
                            : ""} */}
            {/* </div>
                        <div className='col-xs-12 col-sm-3 '>
                            <button onClick={(e) => acknowledged(e)} style={{ float: 'right' }} className="cred-btn">Acknowledged</button>
                        </div>
                    </div>
                    <div className="row g-0">

                        <div className='col-sm-2 col-xs-12'></div>
                        <div className="col-sm-8 col-xs-12">
                            <hr />

                            <div className='box bg-shadow'>
                                <div className="position-relative">
                                    <div className="chat-messages p-4">
                                        {logsData && logsData.data && logsData.data.map((row, i) => {
                                            return (
                                                <div key={i}>
                                                    {row.operationId ?
                                                        <div className="chat-message-right pb-4">
                                                            <div className="flex-shrink-1 bg-you rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>

                                                                <div className='row'>
                                                                    <div className="font-weight-bold mb-1 col-md-6">{row["operationName"]}</div>
                                                                    <div className="mb-1 col-md-4" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                                </div>

                                                                {row["body"]}
                                                            </div>
                                                            {
                                                                window.location.href.includes('/admin') ?
                                                                    <div className='ml-2 mt-3'>
                                                                        <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                    </div> : ""
                                                            }
                                                        </div> :
                                                        <div className="chat-message-left pb-4">
                                                            <div className="flecommunityNamex-shrink-1 bg-other rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>

                                                                <div className='row'>
                                                                    <div className="font-weight-bold mb-1 col-md-6">{row["communityName"] ? row["communityName"] : row["lenderName"] ? row["lenderName"] : row["userId"] ? row.userName : ""}</div>
                                                                    <div className="mb-1 col-md-4" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                                </div>

                                                                {row["body"]}
                                                            </div>
                                                            {
                                                                window.location.href.includes('/admin') ?
                                                                    <div className='ml-2 mt-3'>
                                                                        <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                    </div> : ""
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })} */}
            {/* {logsData && logsData.data && logsData.data.map((row, i) => {
                                        return (
                                            window.location.href.includes('admin/leadDetail') || window.location.href.includes('lender/leadDetail') ?
                                                <div key={i}>
                                                    </div>
                                        )}) */}
            {/* {
                                                        row.communityId ?
                                                            <div className="chat-message-left pb-4">
                                                                <div className="flex-shrink-1 bg-other rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>

                                                                    <div className='row'>
                                                                        <div className="font-weight-bold mb-1 col-md-6">{row["communityName"]}</div>
                                                                        <div className="mb-1 col-md-4" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                                    </div>

                                                                    {row["body"]}
                                                                </div>
                                                                {
                                                                    window.location.href.includes('/admin') ?
                                                                        <div className='ml-2 mt-3'>
                                                                            <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                        </div> : ""
                                                                }
                                                            </div> : ""}{
                                                        row.userId ?
                                                            <div className="chat-message-left pb-4" >
                                                                <div className="flex-shrink-1 bg-user rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>
                                                                    <div className='row'>
                                                                        <div className="font-weight-bold mb-1 col-md-6">{row["userName"]}</div>
                                                                        <div className="mb-1 col-md-6" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>

                                                                    </div>
                                                                    {row["body"]}
                                                                </div>
                                                                {
                                                                    window.location.href.includes('/admin') ?
                                                                        <div className='ml-2 mt-3'>
                                                                            <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                        </div> : ""
                                                                }


                                                            </div> : ""}{
                                                       row.operationId?
                                                            <div className="chat-message-right mb-4">
                                                                <div className="flex-shrink-1 bg-you rounded py-2 px-3 mr-3" style={{ minWidth: '250px' }}>
                                                                    <div className='row'>
                                                                        <div className="font-weight-bold mb-1 col-md-6">{row["operationName"]}</div>
                                                                        <div className="mb-1 col-md-6" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                                    </div>


                                                                    {row["body"]}
                                                                </div>
                                                                {
                                                                    window.location.href.includes('/admin') ?
                                                                        <div className='mr-2 mt-3'>
                                                                            <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                        </div> : ""
                                                                }

                                                            </div> : ""}
                                                </div>
                                                : window.location.href.includes('community/leadDetail') ?
                                                    <div key={i}>
                                                        {
                                                            row.lenderId ?
                                                                <div className="chat-message-left pb-4">
                                                                    <div className="flex-shrink-1 bg-other rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>
                                                                        <div className='row'>
                                                                            <div className="font-weight-bold mb-1 col-md-6">{row["lenderName"]}</div>
                                                                            <div className="mb-1 col-md-6" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')} <i className='fa fa-delete' /></div>
                                                                        </div>
                                                                        {row["body"]}
                                                                    </div>
                                                                    {
                                                                        window.location.href.includes('/admin') ?
                                                                            <div className='ml-2 mt-3'>
                                                                                <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                            </div> : ""
                                                                    }
                                                                </div> : ""}{
                                                            row.userId ?
                                                                <div className="chat-message-left pb-4">
                                                                    <div className="flex-shrink-1 bg-user rounded py-2 px-3 ml-3" style={{ minWidth: '250px' }}>
                                                                        <div className='row'>
                                                                            <div className="font-weight-bold mb-1 col-md-6">{row["userName"]}</div>
                                                                            <div className="mb-1 col-md-6" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')} <i className='fa fa-delete' /></div>
                                                                        </div>
                                                                        {row["body"]}
                                                                    </div>
                                                                    {
                                                                        window.location.href.includes('/admin') ?
                                                                            <div className='ml-2 mt-3'>
                                                                                <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                            </div> : ""
                                                                    }
                                                                </div> : ""}{
                                                            row.communityId ?
                                                                <div className="chat-message-right mb-4">
                                                                    <div className="flex-shrink-1 bg-you rounded py-2 px-3 mr-3" style={{ minWidth: '250px' }}>
                                                                        <div className='row'>
                                                                            <div className="font-weight-bold mb-1 col-md-6">{row["communityName"]}</div>
                                                                            <div className="mb-1 col-md-6" style={{ fontSize: '9px' }}>{moment(row["addedOn"]).format('DD-MM-YYYY hh:mm')}</div>
                                                                        </div>
                                                                        {row["body"]}
                                                                    </div>
                                                                    {
                                                                        window.location.href.includes('/admin') ?
                                                                            <div className='mr-2 mt-3'>
                                                                                <button onClick={(e) => deleteComments(row.id)}> <i className='fa fa-trash' style={{ cursor: "pointer" }} /></button>
                                                                            </div> : ""
                                                                    }
                                                                </div> : ""}
                                                    </div>
                                                    : ""
                                        )
                                    })} */}

            {/* <div ref={bottomRef} ></div> */}

            {/* </div> */}

            {/* // </div> */}

            {/* {(rolesData && rolesData.includes("comments")) || window.location.href.includes('community/leadDetail') ?
                                    <div className="flex-grow-0 py-3 px-4 border-top">
                                        <div className=" row">

                                            <div className='col-xs-12 col-sm-9'>
                                                <TextField variant='standard' size='small' onChange={(e) => commentChangeHandler(e)} type="text" className="form-control" value={comment} label="Add Comment" />
                                            </div>
                                            {!window.location.href.includes('admin') ?
                                                <div className='col-xs-12 col-sm-3 mt-3'>
                                                    <button onClick={(e) => commentHandler(e)} className="cred-btn">Add Comment</button>
                                                </div>
                                                : ""}
                                            {window.location.href.includes('admin') ?
                                                // <div className='row'>
                                                //     <div className='col-xs-12 col-sm-4'>
                                                //     </div>
                                                <div className='col-xs-12 col-md-3 mt-3'>
                                                    <button onClick={(e) => adminCommentHandler(e)} className="cred-btn">Add Comment</button>
                                                </div>
                                                // <div className='col-xs-12 col-sm-4'>
                                                // </div>
                                                // </div>
                                                : ""}
                                        </div>
                                    </div>
                                    : ""} */}

            {/* </div> */}
            {/* // </div> */}
            {/* // </div> */}

        </div>
        // </div>
    )
}

export default ChatScreen;